import React from 'react'
import cn from 'classnames'

import styles from './styles.module.css'

interface BarProps {
  className?: string
  value: number
  color: string
}

export function Bar(props: Readonly<BarProps>) {
  const { value, color, className = '' } = props
  return (
    <div
      data-testid="bar"
      className={cn(styles.bar, className)}
      style={
        {
          '--length': `${value}%`,
          '--color': color,
        } as React.CSSProperties
      }
    />
  )
}
